import { render, staticRenderFns } from "./FooterRequest.vue?vue&type=template&id=027af9c4&scoped=true"
import script from "./FooterRequest.vue?vue&type=script&lang=js"
export * from "./FooterRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027af9c4",
  null
  
)

export default component.exports